import mirakurun from 'mirakurun';

export default interface IMirakurunClientModel {
    getClient(): mirakurun;
}
